<script>
import { mapState } from 'vuex';

export default{
  methods: {
    filterCountryList(val){
      return this.countryList.filter(el=>el?.toLowerCase().match(val?.toLowerCase())).slice(0, 4)
    }
  },
  computed: {
    ...mapState(['countryList'])
  }
}
</script>